import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'qset-review-subtask';

const ELEMENTS = define({
  // The subtask's status tag is the durable signal that a review was submitted
  // (In Review -> Reviewed). It is a plain `Label` with no role, and the same
  // texts appear on the parent task's subtask cards, so it needs its own id.
  STATUS_TAG: ['status', 'tag'],
  // "Submit Review" is unique by name today, but the spec asserts that it
  // *disappears* once the review is submitted, and a hidden-element assertion
  // should not hinge on a button label that copy changes can move.
  SUBMIT_REVIEW_BUTTON: ['submit-review', 'button'],
});

export const QSET_REVIEW_SUBTASK_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
